import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {FlowChartDataService} from "@features/data-survey/services/flow-chart-data.service";
import {EliteFormFlowChartDataService} from "@features/elite-form/services/elite-form-flow-chart-data.service";
import {EliteFormManagerService} from "@features/elite-form/services/elite-form-manager.service";
import {EliteFormServiceFactory} from "@features/elite-form/services/elite-form-service-factory.service";
import {FormResponseViewService} from "@features/elite-form/services/form-response-view.service";
import {CommandService} from "@core/services/command.service";
import {take, takeUntil} from "rxjs/operators";
import {Guid} from "guid-typescript";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {Router} from "@angular/router";
import {FileManagementService} from "@core/services/file-management.service";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'app-platform-tool-elite-form-response',
  templateUrl: './platform-tool-elite-form-response.component.html',
  styleUrls: ['./platform-tool-elite-form-response.component.scss']
})
export class PlatformToolEliteFormResponseComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  eliteFormId: string;
  private autoSaveCommand: PlatformCommand;
  itemId: string;
  private eliteFormManagerService: EliteFormManagerService;
  hasFillableForm: boolean;
  isGovernmentFillableOnly:boolean;
  formAvailabilityMessage: string | null = null;
  formAvailabilityMessageTitle: string = 'Form Availability';
  unSubscribe$ = new Subject<void>()
  constructor(
    private flowChartDataService: FlowChartDataService,
    private eliteFormFlowChartDataService: EliteFormFlowChartDataService,
    private formResponseViewService: FormResponseViewService,
    private eliteFormServiceFactory: EliteFormServiceFactory,
    public commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private fileManagementService: FileManagementService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.initializeEnv();
    this.eliteFormManagerService = this.eliteFormServiceFactory.getEliteFormManagerService(this.eliteFormId);
    this.itemId = this.selectedTab.tabData['DataItemId'];
    this.eliteFormFlowChartDataService.schemaId = this.magicLinkModel.fieldValues['SchemaId'];
    this.eliteFormFlowChartDataService.responseId = this.magicLinkModel.fieldValues['ResponseId'];
    this.eliteFormFlowChartDataService.isClientSchema = this.magicLinkModel.fieldValues['IsClientSchema'];
    this.autoSaveCommand = this.magicLinkModel.additionalCommands['AutoSaveCommand'];
    this.autoSaveCommand = this.formResponseViewService.initAutoSaveCommand(
      this.autoSaveCommand,
      this.eliteFormFlowChartDataService.responseId,
      this.magicLinkModel.fieldValues['SchemaId'],
      this.magicLinkModel.fieldValues['IsClientSchema']
    );
    this.hasFillableForm = this.magicLinkModel?.fieldValues['HasFillableForm'];
    this.isGovernmentFillableOnly = this.magicLinkModel?.fieldValues['IsGovernmentFillableOnly'];
    this.formAvailabilityMessage = this.magicLinkModel?.fieldValues['FormAvailabilityMessage'] || null;
    this.formAvailabilityMessageTitle = this.magicLinkModel?.fieldValues['FormAvailabilityMessageTitle'] || 'Form Availability';
  }

  private initializeEnv() {
    this.eliteFormFlowChartDataService.initFlowchartData();
    this.eliteFormFlowChartDataService.excludeHiddenQuestion(true);
    this.eliteFormFlowChartDataService.setApi(this.selectedTab.tabData.Api);
    this.eliteFormFlowChartDataService.setIsClientDrive(this.selectedTab.tabData['IsClientDrive']);
    this.eliteFormId = this.selectedTab.tabData['EliteFormId'];
    // this.eliteFormFlowChartDataService.setFlowchartId(this.eliteFormId);
    this.eliteFormFlowChartDataService.setSourceType(this.selectedTab.tabData['SourceType']);
  }

  onFormValueChange(event){
    this.formResponseViewService.updateFieldValue(this.autoSaveCommand, event.fieldKey, event.fieldValue);
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }
  openFormInstructions(){
    const newCommand = this.magicLinkModel?.additionalCommands["instructions"];
    this.executePlatformCommand(newCommand);
  }

  executePlatformCommand(command: PlatformCommand) {
    if(command.fieldValues['IsFormDataRefreshStarted']){
      this.fuseSplashScreenService.show();
      this.fuseSplashScreenService.showWaitScreenMessage(`Form data refreshing in progress...`);
    }
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response.fieldValues['DownloadUrl'] && response.fieldValues['FileName']) {
          this.fileManagementService.downloadOneTimeSignedUrl(response.fieldValues['DownloadUrl'], response.fieldValues['FileName']);
          return;
        }
        if (response.fieldValues['DownloadFileResponseModel']) {
          const downloadResponseModel = response.fieldValues['DownloadFileResponseModel'];
          const fileId = downloadResponseModel?.fileId;
          this.fileManagementService.downloadClientFileWithId(fileId).pipe(take(1)).subscribe(payload => {
            this.fuseSplashScreenService.hide();
            this.fileManagementService.openSaveFileWindow(payload, downloadResponseModel.fileName);
          });
        }
        if(response?.fieldValues['RedirectCommand']) {
          this.executePlatformCommand(response.fieldValues['RedirectCommand']);
        } else if (response.fieldValues['RedirectUrl']) {
          if (response.fieldValues['PlatformLinkModel']) {
            this.commandService.handleResponse(response);
            this.invalidateSubject.invalidate('HardReload' + Guid.create().toString());
            return;
          }
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
          return;
        }
        else if (response.fieldValues['RedirectToExternalUrl']) {
          window.open(response.fieldValues['RedirectToExternalUrl']);
          return;
        }
        if (response.fieldValues['Refresh']) {
          this.fuseSplashScreenService.hide();
          this.reloadPage();
          //QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error(`${command.name} failed!!!`, error);
      }
    );
  }
  reloadPage() {
    this.router.navigate([this.router.url])
      .then(() => {
        window.location.reload();
      });
  }
  onLoad() {
  }
}
